module.exports = __webpack_public_path__ + "static/img/banner07.20aa01ce.png";